module.exports = __webpack_public_path__ + "img/TSY.a5412c89.jpg";